import { ResourceManager } from "@/components/ResourceManager";
import { HeartHandshake } from "lucide-react";

const fields = [
  { name: "full_name", label: "Full Name", type: "text", required: true },
  { name: "mobile", label: "Mobile", type: "text" },
  { name: "email", label: "Email", type: "text" },
  { name: "address", label: "Address", type: "text", table: false },
  { name: "skills", label: "Skills", type: "text", table: false },
  { name: "interests", label: "Interests", type: "text" },
  { name: "availability", label: "Availability", type: "text", table: false },
  { name: "status", label: "Status", type: "select", options: ["Active", "Pending", "Inactive"] },
];

export default function VolunteersAdmin() {
  return <ResourceManager title="Volunteers" eyebrow="Community" endpoint="volunteers" fields={fields} idField="volunteer_id" icon={HeartHandshake} />;
}
